'use strict';

angular.module('contartemx.cuenta.facturacion',[
	'contartemx',
	'ui.router',
	'ui.bootstrap',
	'ngTable'
])

.controller('FacturacionCtrl', function FacturacionController($scope, $state, NgTableParams, $http, $uibModal, $filter, callToWebService){
    
  $scope.llamado = true;
  $scope.Historial = [];
  $scope.$watch("llamado", function () {
    callToWebService.postCall('ObtenerPantallaHistorialDeCompras', {},
      function sucess(data){
      	$scope.NombreMembresia = data.Respuesta.NombreMembresia;
      	$scope.PrecioMembresia = data.Respuesta.PrecioMembresia;
      	$scope.TieneMembresiaActiva = data.Respuesta.TieneMembresiaActiva;
      	$scope.Historial = data.Respuesta.Historial;
      	$scope.tableParams.sorting.FechaDeCompra = "desc";
      },
      function error(data){
        mostrarNotificacion.error(data.Mensaje);
      });
  }, true);

	$scope.tableParams = new NgTableParams({
        sorting: {
            FechaDeCompra: "asc"
        }
    });

    $scope.$watch("tableParams", function (params, paramsOld) {
    	if(params.sorting != paramsOld.sorting){
    		$scope.Historial = $scope.tableParams.sorting ? $filter('orderBy')($scope.Historial, $scope.tableParams.orderBy()) : $scope.Historial;
    	}
    }, true);

});
